import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useAuthModal } from '../../../contexts/AuthModalContext';

const CTASection = () => {
  const navigate = useNavigate();
  const { openAuthModal } = useAuthModal();

  return (
    <section className="relative overflow-hidden bg-[var(--lp-contrast-bg)] py-24 text-[var(--lp-contrast-text)] lg:py-28">
      <div className="lp-grain absolute inset-0" />
      <div className="absolute left-1/2 top-0 h-64 w-[600px] -translate-x-1/2 rounded-full bg-[var(--lp-accent)]/15 blur-[100px]" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="font-mono text-[11px] font-semiboldtracking-[0.25em] text-[var(--lp-accent)]">
            Your next round
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-[1.05] tracking-tight text-[var(--lp-contrast-text)] sm:text-5xl lg:text-6xl">
            Stop rehearsing alone.
            <span className="block text-[var(--lp-contrast-text)]/45">Start sparring with AI tonight.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-[var(--lp-contrast-text)]/55">
            Create an account, launch a realistic mock interview, and get a full scorecard with focused practice history.
          </p>

          <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
            <Button
              size="lg"
              onClick={() => openAuthModal('register', { redirectTo: '/interview-setup' })}
              className="h-12 rounded-full bg-[var(--lp-accent)] px-8 text-sm font-semibold text-white hover:bg-[var(--lp-accent)]/90"
              iconName="ArrowRight"
              iconPosition="right"
            >
              Create account
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/interview-setup')}
              className="h-12 rounded-full border-[var(--lp-contrast-text)]/20 bg-transparent px-8 text-sm font-semibold text-[var(--lp-contrast-text)] hover:bg-[var(--lp-contrast-text)]/10"
              iconName="Mic"
            >
              Jump into a mock
            </Button>
          </div>

          <ul className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3">
            {['Google signup', 'Voice · code · design', 'Instant scorecard'].map((item) => (
              <li key={item} className="flex items-center gap-2 text-sm text-[var(--lp-contrast-text)]/60">
                <Icon name="Check" size={14} className="text-[var(--lp-accent)]" />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
